var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSanadLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 355.267,
    height: 71.056,
    viewBox: "0 0 355.267 71.056",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_9",
    "data-name": "Group 9",
    transform: "translate(-454.274 -6.636)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6",
    "data-name": "Group 6",
    transform: "translate(454.274 17.963)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1",
    "data-name": "Group 1",
    transform: "translate(0 38.295)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1",
    "data-name": "Path 1",
    d: "M463.34,28.623a3.564,3.564,0,0,1-1.363,2.964,5.945,5.945,0,0,1-3.769,1.078,8.991,8.991,0,0,1-3.934-.749V29.73a10.618,10.618,0,0,0,2.06.714,8.806,8.806,0,0,0,2.03.264,3.246,3.246,0,0,0,2.03-.524,1.719,1.719,0,0,0,.653-1.406,1.77,1.77,0,0,0-.6-1.346,9.075,9.075,0,0,0-2.48-1.307,6.543,6.543,0,0,1-2.731-1.792,3.78,3.78,0,0,1-.8-2.423,3.4,3.4,0,0,1,1.259-2.791,5.245,5.245,0,0,1,3.38-1.017,9.945,9.945,0,0,1,4.051.891l-.736,1.891a8.888,8.888,0,0,0-3.371-.8,2.593,2.593,0,0,0-1.705.489,1.6,1.6,0,0,0-.58,1.294,1.845,1.845,0,0,0,.229.943,2.384,2.384,0,0,0,.766.744,13.382,13.382,0,0,0,1.917.917,10.567,10.567,0,0,1,2.289,1.212A3.555,3.555,0,0,1,463,26.956,3.843,3.843,0,0,1,463.34,28.623Z",
    transform: "translate(-454.274 -18.102)",
    fill: "#ff6b00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2",
    "data-name": "Path 2",
    d: "M467.225,32.357l-1.415-3.934H460.4l-1.385,3.934h-2.441l5.3-14.221h2.519l5.3,14.221ZM465.2,26.428l-1.329-3.856c-.1-.26-.229-.666-.4-1.22s-.29-.961-.355-1.22a22.724,22.724,0,0,1-.766,2.605l-1.281,3.691Z",
    transform: "translate(-446.63 -17.989)",
    fill: "#ff6b00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3",
    "data-name": "Path 3",
    d: "M471.834,32.313H469l-6.963-11.287h-.078l.048.632q.136,1.8.134,3.293v7.361h-2.1V18.149h2.813l6.946,11.23h.056c-.013-.151-.039-.688-.078-1.623s-.056-1.662-.056-2.185V18.149h2.121Z",
    transform: "translate(-435.11 -17.946)",
    fill: "#ff6b00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4",
    "data-name": "Path 4",
    d: "M473.847,32.357l-1.415-3.934h-5.414l-1.385,3.934h-2.441l5.3-14.221h2.519l5.3,14.221Zm-2.025-5.929L470.5,22.572q-.149-.389-.4-1.22c-.173-.554-.29-.961-.355-1.22a21.106,21.106,0,0,1-.766,2.605L467.7,26.428Z",
    transform: "translate(-424.598 -17.989)",
    fill: "#ff6b00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5",
    "data-name": "Path 5",
    d: "M478.171,25.095a7.047,7.047,0,0,1-1.948,5.362,7.817,7.817,0,0,1-5.608,1.857h-3.96V18.149h4.375a7.263,7.263,0,0,1,5.263,1.822A6.814,6.814,0,0,1,478.171,25.095Zm-2.441.078q0-5.083-4.756-5.085h-2V30.366h1.645Q475.73,30.366,475.73,25.173Z",
    transform: "translate(-413.074 -17.946)",
    fill: "#ff6b00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6",
    "data-name": "Path 6",
    d: "M473.5,32.313H471.21V18.149H479.2v1.96h-5.7v4.427h5.341V26.5H473.5Z",
    transform: "translate(-397.917 -17.946)",
    fill: "#ff6b00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7",
    "data-name": "Path 7",
    d: "M473.65,32.313V18.149h2.315V32.313Z",
    transform: "translate(-389.797 -17.946)",
    fill: "#ff6b00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8",
    "data-name": "Path 8",
    d: "M486.846,32.313h-2.839l-6.963-11.287h-.078l.048.632q.136,1.8.134,3.293v7.361h-2.1V18.149h2.809l6.946,11.23h.056c-.013-.151-.039-.688-.078-1.623s-.056-1.662-.056-2.185V18.149h2.121Z",
    transform: "translate(-385.142 -17.946)",
    fill: "#ff6b00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9",
    "data-name": "Path 9",
    d: "M488.862,32.357l-1.415-3.934h-5.414l-1.385,3.934h-2.441l5.3-14.221h2.519l5.3,14.221Zm-2.025-5.929-1.324-3.856q-.149-.389-.4-1.22c-.173-.554-.29-.961-.355-1.22a21.109,21.109,0,0,1-.766,2.605l-1.277,3.691Z",
    transform: "translate(-374.633 -17.989)",
    fill: "#ff6b00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10",
    "data-name": "Path 10",
    d: "M493.467,32.313h-2.839l-6.963-11.287h-.078l.048.632q.136,1.8.139,3.293v7.361h-2.1V18.149h2.809l6.946,11.23h.056c-.013-.151-.039-.688-.078-1.623s-.056-1.662-.056-2.185V18.149h2.12Z",
    transform: "translate(-363.11 -17.946)",
    fill: "#ff6b00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11",
    "data-name": "Path 11",
    d: "M491.82,20.088a3.815,3.815,0,0,0-3.138,1.415,6.052,6.052,0,0,0-1.143,3.9,6.091,6.091,0,0,0,1.1,3.942,3.889,3.889,0,0,0,3.181,1.337,8.512,8.512,0,0,0,1.744-.177c.563-.121,1.147-.273,1.757-.463v1.986a10.639,10.639,0,0,1-3.778.632,6.035,6.035,0,0,1-4.778-1.887A7.866,7.866,0,0,1,485.1,25.39a8.674,8.674,0,0,1,.809-3.865,5.788,5.788,0,0,1,2.337-2.54,7.078,7.078,0,0,1,3.6-.883,8.952,8.952,0,0,1,4.012.913l-.835,1.926a12.1,12.1,0,0,0-1.515-.593A5.415,5.415,0,0,0,491.82,20.088Z",
    transform: "translate(-351.699 -18.102)",
    fill: "#ff6b00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12",
    "data-name": "Path 12",
    d: "M488.166,32.313V18.149h2.315V32.313Z",
    transform: "translate(-341.493 -17.946)",
    fill: "#ff6b00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13",
    "data-name": "Path 13",
    d: "M499.788,32.357l-1.415-3.934h-5.414l-1.385,3.934h-2.441l5.3-14.221h2.519l5.3,14.221Zm-2.025-5.929-1.329-3.856q-.143-.389-.4-1.22t-.351-1.22a22.72,22.72,0,0,1-.766,2.605l-1.281,3.691Z",
    transform: "translate(-338.275 -17.989)",
    fill: "#ff6b00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14",
    "data-name": "Path 14",
    d: "M492.595,32.313V18.149h2.315V30.327h6v1.986Z",
    transform: "translate(-326.755 -17.946)",
    fill: "#ff6b00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15",
    "data-name": "Path 15",
    d: "M505.129,28.623a3.567,3.567,0,0,1-1.367,2.964,5.936,5.936,0,0,1-3.769,1.078,8.958,8.958,0,0,1-3.93-.749V29.73a10.578,10.578,0,0,0,2.056.714,8.8,8.8,0,0,0,2.03.264,3.247,3.247,0,0,0,2.03-.524,1.707,1.707,0,0,0,.653-1.406,1.755,1.755,0,0,0-.6-1.346,8.937,8.937,0,0,0-2.48-1.307,6.6,6.6,0,0,1-2.731-1.792,3.8,3.8,0,0,1-.792-2.423,3.4,3.4,0,0,1,1.259-2.791,5.237,5.237,0,0,1,3.38-1.017,9.941,9.941,0,0,1,4.046.891l-.736,1.891a8.869,8.869,0,0,0-3.367-.8,2.605,2.605,0,0,0-1.709.489,1.617,1.617,0,0,0-.58,1.294,1.8,1.8,0,0,0,.234.943,2.384,2.384,0,0,0,.766.744,13.388,13.388,0,0,0,1.917.917,10.615,10.615,0,0,1,2.285,1.212,3.555,3.555,0,0,1,1.065,1.268A3.782,3.782,0,0,1,505.129,28.623Z",
    transform: "translate(-315.215 -18.102)",
    fill: "#ff6b00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16",
    "data-name": "Path 16",
    d: "M506.8,32.313h-8.011V18.149H506.8v1.96h-5.7v3.852h5.336V25.9h-5.336v4.449h5.7Z",
    transform: "translate(-306.137 -17.946)",
    fill: "#ff6b00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17",
    "data-name": "Path 17",
    d: "M503.665,26.657v5.656H501.35V18.149h4a6.582,6.582,0,0,1,4.059,1.03,3.684,3.684,0,0,1,1.316,3.1,3.874,3.874,0,0,1-2.748,3.769l4,6.266h-2.635l-3.389-5.656Zm0-1.917h1.606a3.692,3.692,0,0,0,2.345-.6,2.183,2.183,0,0,0,.727-1.783,1.913,1.913,0,0,0-.788-1.722,4.267,4.267,0,0,0-2.363-.524h-1.528Z",
    transform: "translate(-297.621 -17.946)",
    fill: "#ff6b00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18",
    "data-name": "Path 18",
    d: "M513.784,18.149h2.4l-4.955,14.164H508.79l-4.942-14.164h2.38l2.956,8.807q.234.63.493,1.623c.177.662.29,1.155.342,1.476.082-.489.212-1.056.385-1.7s.316-1.125.428-1.437Z",
    transform: "translate(-289.309 -17.946)",
    fill: "#ff6b00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_19",
    "data-name": "Path 19",
    d: "M507.132,32.313V18.149h2.311V32.313Z",
    transform: "translate(-278.381 -17.946)",
    fill: "#ff6b00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20",
    "data-name": "Path 20",
    d: "M515.094,20.088a3.809,3.809,0,0,0-3.137,1.415,6.027,6.027,0,0,0-1.147,3.9,6.092,6.092,0,0,0,1.1,3.942,3.892,3.892,0,0,0,3.185,1.337,8.543,8.543,0,0,0,1.744-.177c.558-.121,1.147-.273,1.753-.463v1.986a10.638,10.638,0,0,1-3.778.632,6.035,6.035,0,0,1-4.778-1.887,7.888,7.888,0,0,1-1.666-5.388,8.734,8.734,0,0,1,.809-3.865,5.772,5.772,0,0,1,2.341-2.54,7.061,7.061,0,0,1,3.592-.883,8.925,8.925,0,0,1,4.012.913l-.831,1.926a12.454,12.454,0,0,0-1.519-.593A5.389,5.389,0,0,0,515.094,20.088Z",
    transform: "translate(-274.265 -18.102)",
    fill: "#ff6b00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21",
    "data-name": "Path 21",
    d: "M519.446,32.313h-8.01V18.149h8.01v1.96h-5.7v3.852h5.336V25.9h-5.336v4.449h5.7Z",
    transform: "translate(-264.059 -17.946)",
    fill: "#ff6b00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22",
    "data-name": "Path 22",
    d: "M522.852,28.623a3.564,3.564,0,0,1-1.363,2.964,5.944,5.944,0,0,1-3.769,1.078,8.99,8.99,0,0,1-3.934-.749V29.73a10.618,10.618,0,0,0,2.06.714,8.8,8.8,0,0,0,2.03.264,3.247,3.247,0,0,0,2.03-.524,1.719,1.719,0,0,0,.653-1.406,1.755,1.755,0,0,0-.6-1.346,8.933,8.933,0,0,0-2.48-1.307,6.573,6.573,0,0,1-2.731-1.792,3.8,3.8,0,0,1-.8-2.423,3.4,3.4,0,0,1,1.259-2.791,5.25,5.25,0,0,1,3.384-1.017,9.941,9.941,0,0,1,4.046.891l-.736,1.891a8.889,8.889,0,0,0-3.371-.8,2.6,2.6,0,0,0-1.7.489,1.617,1.617,0,0,0-.58,1.294,1.845,1.845,0,0,0,.23.943,2.38,2.38,0,0,0,.766.744,13.243,13.243,0,0,0,1.921.917,10.621,10.621,0,0,1,2.285,1.212,3.555,3.555,0,0,1,1.065,1.268A3.842,3.842,0,0,1,522.852,28.623Z",
    transform: "translate(-256.239 -18.102)",
    fill: "#ff6b00"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5",
    "data-name": "Group 5",
    transform: "translate(0.312)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2",
    "data-name": "Group 2"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1",
    "data-name": "Rectangle 1",
    width: 3.051,
    height: 3.225,
    rx: 0.08,
    transform: "translate(7.249 1.352)",
    fill: "#003d69"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2",
    "data-name": "Rectangle 2",
    width: 3.051,
    height: 3.225,
    rx: 0.08,
    transform: "translate(3.019 1.352)",
    fill: "#003d69"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3",
    "data-name": "Rectangle 3",
    width: 3.051,
    height: 3.225,
    rx: 0.08,
    transform: "translate(17.755 26.803)",
    fill: "#003d69"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4",
    "data-name": "Rectangle 4",
    width: 3.051,
    height: 3.225,
    rx: 0.08,
    transform: "translate(21.985 26.803)",
    fill: "#003d69"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_23",
    "data-name": "Path 23",
    d: "M487.565,9.253h-2.22A.307.307,0,0,0,485,9.6V28.29a2.023,2.023,0,0,1-.4,1.437,1.716,1.716,0,0,1-1.264.4h-2.6a3.914,3.914,0,0,1-2.272-.589,2.009,2.009,0,0,1-.848-1.77V18.995a.308.308,0,0,0-.351-.346h-2.216a.305.305,0,0,0-.346.346v9.3a2,2,0,0,1-.4,1.437,1.717,1.717,0,0,1-1.264.4h-2.359l-.13,0-.113,0h-1.523a1.721,1.721,0,0,1-1.268-.4,2.022,2.022,0,0,1-.4-1.437V16.532a.307.307,0,0,0-.346-.346h-2.22a.307.307,0,0,0-.346.346v1.493h-3.4a8.47,8.47,0,0,0-2.48.364,5.446,5.446,0,0,0-2.1,1.181A5.84,5.84,0,0,0,454.9,21.7a8.373,8.373,0,0,0-.558,3.259,7.454,7.454,0,0,0,.489,2.826,5.3,5.3,0,0,0,1.333,1.978,5.48,5.48,0,0,0,2.012,1.164,8.1,8.1,0,0,0,2.514.381A6.862,6.862,0,0,0,462.807,31a4.59,4.59,0,0,0,1.666-.939,3.221,3.221,0,0,0,1.263,2.134,4.716,4.716,0,0,0,2.653.64h5.167q2.739,0,3.6-1.8a3.037,3.037,0,0,0,1.285,1.35,4.039,4.039,0,0,0,1.943.45h3.466a3.988,3.988,0,0,0,3.12-1.056,4.909,4.909,0,0,0,.935-3.311V9.6A.307.307,0,0,0,487.565,9.253ZM464.334,24.2a5.589,5.589,0,0,1-.814,3.241,3.176,3.176,0,0,1-2.791,1.164,3.424,3.424,0,0,1-2.566-.922,3.729,3.729,0,0,1-.9-2.722,4.326,4.326,0,0,1,1.026-3.311,3.826,3.826,0,0,1,2.653-.917h3.4Z",
    transform: "translate(-454.346 -9.253)",
    fill: "#003d69"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_24",
    "data-name": "Path 24",
    d: "M495.885,9.253h-2.22a.307.307,0,0,0-.346.346V28.29a2.022,2.022,0,0,1-.4,1.437,1.716,1.716,0,0,1-1.263.4H488.5a2.064,2.064,0,0,1-1.441-.64,3.391,3.391,0,0,1-.71-2.411q.033-.344.052-.727c.009-.255.017-.511.017-.762q0-3.992-1.77-5.773a7.483,7.483,0,0,0-9.707,0q-1.772,1.785-1.77,5.773v.71c0,.221.013.446.035.675a5.175,5.175,0,0,1-.19,1.51,2.719,2.719,0,0,1-.5.969,1.848,1.848,0,0,1-.693.519,2.018,2.018,0,0,1-.766.156H467.8a1.716,1.716,0,0,1-1.264-.4,2.022,2.022,0,0,1-.4-1.437V9.6a.307.307,0,0,0-.346-.346h-2.22a.305.305,0,0,0-.346.346V28.463a4.909,4.909,0,0,0,.935,3.311,3.988,3.988,0,0,0,3.12,1.056h3.536a8.392,8.392,0,0,0,2.116-.294,3.14,3.14,0,0,0,1.874-1.4,5.081,5.081,0,0,0,2.116,1.471,8.158,8.158,0,0,0,2.878.467,8.305,8.305,0,0,0,2.843-.45,4.939,4.939,0,0,0,2.112-1.454,2.975,2.975,0,0,0,.835.883,3.932,3.932,0,0,0,1.021.5,5.039,5.039,0,0,0,1.091.225c.372.035.718.052,1.043.052h3.432a3.988,3.988,0,0,0,3.12-1.056,4.91,4.91,0,0,0,.935-3.311V9.6A.307.307,0,0,0,495.885,9.253Zm-13.26,19.972a4.066,4.066,0,0,1-5.652,0,5.954,5.954,0,0,1-.887-3.64,6.211,6.211,0,0,1,.887-3.575,3.758,3.758,0,0,1,5.652,0,6.247,6.247,0,0,1,.883,3.575A5.987,5.987,0,0,1,482.625,29.225Z",
    transform: "translate(-424.803 -9.253)",
    fill: "#003d69"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_25",
    "data-name": "Path 25",
    d: "M474.886,32.484a.307.307,0,0,1-.346.346h-2.22a.307.307,0,0,1-.346-.346V9.6a.307.307,0,0,1,.346-.346h2.22a.307.307,0,0,1,.346.346Z",
    transform: "translate(-395.689 -9.253)",
    fill: "#003d69"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_26",
    "data-name": "Path 26",
    d: "M497.058,26.047a2.022,2.022,0,0,0,.4-1.437v-9.3a.307.307,0,0,1,.346-.346h2.22a.307.307,0,0,1,.346.346v9.469a4.91,4.91,0,0,1-.935,3.311,4.088,4.088,0,0,1-3.189,1.056H479.565a3.982,3.982,0,0,1-3.12-1.056,4.886,4.886,0,0,1-.939-3.311V17.534a.307.307,0,0,1,.346-.346h2.22a.305.305,0,0,1,.346.346V24.61a2.023,2.023,0,0,0,.4,1.437,1.728,1.728,0,0,0,1.268.4h15.67A1.785,1.785,0,0,0,497.058,26.047ZM484.7,13.583a.308.308,0,0,1-.351-.346V10.705a.307.307,0,0,1,.351-.346h2.354a.3.3,0,0,1,.346.346v2.532a.305.305,0,0,1-.346.346Zm4.228,0a.307.307,0,0,1-.346-.346V10.705a.305.305,0,0,1,.346-.346h2.359a.305.305,0,0,1,.346.346v2.532a.307.307,0,0,1-.346.346Z",
    transform: "translate(-383.933 -5.573)",
    fill: "#003d69"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27",
    "data-name": "Path 27",
    d: "M503.7,19.812a7.483,7.483,0,0,0-9.707,0q-1.772,1.785-1.77,5.773v.71c0,.221.013.446.035.675a5.176,5.176,0,0,1-.19,1.51,2.722,2.722,0,0,1-.5.969,1.827,1.827,0,0,1-.7.519,1.981,1.981,0,0,1-.761.156h-3.259a1.716,1.716,0,0,1-1.264-.4,2,2,0,0,1-.4-1.437V9.6a.308.308,0,0,0-.35-.346h-2.216a.305.305,0,0,0-.346.346V28.463a4.91,4.91,0,0,0,.935,3.311,3.982,3.982,0,0,0,3.12,1.056h3.536a8.39,8.39,0,0,0,2.116-.294,3.153,3.153,0,0,0,1.874-1.4,5.094,5.094,0,0,0,2.112,1.471,9.046,9.046,0,0,0,5.635.035,5.165,5.165,0,0,0,2.082-1.333,6.112,6.112,0,0,0,1.315-2.324,10.8,10.8,0,0,0,.472-3.4Q505.465,21.593,503.7,19.812Zm-2.03,9.413a4.066,4.066,0,0,1-5.652,0,5.985,5.985,0,0,1-.883-3.64,6.245,6.245,0,0,1,.883-3.575,3.758,3.758,0,0,1,5.652,0,6.246,6.246,0,0,1,.887,3.575A5.985,5.985,0,0,1,501.665,29.225Z",
    transform: "translate(-361.428 -9.253)",
    fill: "#003d69"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_3",
    "data-name": "Group 3",
    transform: "translate(147.919)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5",
    "data-name": "Rectangle 5",
    width: 3.052,
    height: 3.225,
    rx: 0.08,
    transform: "translate(23.474 2.774)",
    fill: "#003d69"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28",
    "data-name": "Path 28",
    d: "M541.124,9.253H538.9a.307.307,0,0,0-.346.346V28.29a2,2,0,0,1-.4,1.437,1.716,1.716,0,0,1-1.264.4H534.33a3.913,3.913,0,0,1-2.272-.589,2.01,2.01,0,0,1-.848-1.77V9.6a.307.307,0,0,0-.346-.346h-2.22a.305.305,0,0,0-.346.346V28.29a2.022,2.022,0,0,1-.4,1.437,1.727,1.727,0,0,1-1.268.4h-2.566a4.035,4.035,0,0,1-2.2-.537,1.947,1.947,0,0,1-.922-1.61c0-.186,0-.372.017-.558s.017-.381.017-.589a15.582,15.582,0,0,0-.346-3.293A7.341,7.341,0,0,0,519.4,20.73a6.409,6.409,0,0,0-2.411-1.96,8.926,8.926,0,0,0-3.916-.744,7.173,7.173,0,0,0-3.523.8,8.1,8.1,0,0,0-2.411,2.012c-.139.16-.1.325.1.485l1.528,1.251a.317.317,0,0,0,.485-.035,5.884,5.884,0,0,1,1.753-1.32,4.831,4.831,0,0,1,2.168-.485,5.164,5.164,0,0,1,2.25.433,3.517,3.517,0,0,1,1.441,1.251,5.675,5.675,0,0,1,.779,1.939,11.935,11.935,0,0,1,.242,2.48,10.121,10.121,0,0,1-.1,1.58,2.118,2.118,0,0,1-.415,1.021,1.676,1.676,0,0,1-.9.537,6.323,6.323,0,0,1-1.562.156H504.686a3.914,3.914,0,0,1-2.272-.589,2.01,2.01,0,0,1-.848-1.77V24.2a5.981,5.981,0,0,0-1.666-4.678,6.2,6.2,0,0,0-4.3-1.493H490.5a.305.305,0,0,0-.346.346v2.012a.305.305,0,0,0,.346.346h4.02q3.953,0,3.951,3.5v2.774a8.873,8.873,0,0,1-.1,1.493,1.946,1.946,0,0,1-.416.952,1.722,1.722,0,0,1-.9.519,6.322,6.322,0,0,1-1.562.156h-6.621a.307.307,0,0,0-.346.346v2.012a.307.307,0,0,0,.346.346h7.7a7.118,7.118,0,0,0,2.7-.433,3.217,3.217,0,0,0,1.627-1.58,2.782,2.782,0,0,0,1.32,1.51,4.413,4.413,0,0,0,2.112.5h11.655a6.818,6.818,0,0,0,2.648-.45,3.314,3.314,0,0,0,1.649-1.562,2.774,2.774,0,0,0,1.316,1.51,4.441,4.441,0,0,0,2.116.5h3.432q2.739,0,3.609-1.8a3.006,3.006,0,0,0,1.281,1.35,4.039,4.039,0,0,0,1.943.45h3.432a3.988,3.988,0,0,0,3.12-1.056,4.91,4.91,0,0,0,.935-3.311V9.6A.305.305,0,0,0,541.124,9.253Z",
    transform: "translate(-488.526 -9.253)",
    fill: "#003d69"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4",
    "data-name": "Group 4",
    transform: "translate(213.591 2.739)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6",
    "data-name": "Rectangle 6",
    width: 3.052,
    height: 3.224,
    rx: 0.08,
    transform: "translate(20.561)",
    fill: "#003d69"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29",
    "data-name": "Path 29",
    d: "M554.949,11.9h-2.22a.305.305,0,0,0-.346.346v9.3a2.022,2.022,0,0,1-.4,1.437,1.727,1.727,0,0,1-1.268.4h-.866a3.758,3.758,0,0,1-2.22-.589,2.028,2.028,0,0,1-.831-1.77v-5.79a.307.307,0,0,0-.346-.346h-2.22a.307.307,0,0,0-.346.346v6.314a2.023,2.023,0,0,1-.4,1.437,1.728,1.728,0,0,1-1.268.4h-.866a3.758,3.758,0,0,1-2.22-.589,2.027,2.027,0,0,1-.831-1.77v-5.79a.307.307,0,0,0-.346-.346h-2.22a.306.306,0,0,0-.346.346v6.314a2.022,2.022,0,0,1-.4,1.437,1.728,1.728,0,0,1-1.268.4h-3.363a3.914,3.914,0,0,1-2.272-.589,2.009,2.009,0,0,1-.848-1.77V12.249a.307.307,0,0,0-.346-.346h-2.22a.307.307,0,0,0-.346.346v9.3a2.022,2.022,0,0,1-.4,1.437,1.728,1.728,0,0,1-1.268.4h-2.181l-.121,0c-.039,0-.082,0-.121,0h-.385a3.889,3.889,0,0,1-2.268-.589,2.012,2.012,0,0,1-.853-1.77v-3.57a5.981,5.981,0,0,0-1.662-4.678,6.205,6.205,0,0,0-4.3-1.493h-5.1a.307.307,0,0,0-.346.346v2.012a.307.307,0,0,0,.346.346H509.7q3.953,0,3.951,3.5V20.26a8.85,8.85,0,0,1-.1,1.493,1.946,1.946,0,0,1-.415.952,1.724,1.724,0,0,1-.9.519,6.322,6.322,0,0,1-1.562.156h-6.621a.305.305,0,0,0-.346.346v2.012a.305.305,0,0,0,.346.346h7.7a7.118,7.118,0,0,0,2.7-.433,3.218,3.218,0,0,0,1.627-1.58,2.763,2.763,0,0,0,1.32,1.51,4.413,4.413,0,0,0,2.112.5h3.679q2.739,0,3.6-1.8a3,3,0,0,0,1.281,1.35,4.038,4.038,0,0,0,1.943.45h4.228q2.739,0,3.609-1.8a3.005,3.005,0,0,0,1.281,1.35,4.038,4.038,0,0,0,1.943.45h1.662q2.74,0,3.61-1.8a3.005,3.005,0,0,0,1.281,1.35,4.04,4.04,0,0,0,1.943.45h1.662a3.982,3.982,0,0,0,3.12-1.056,4.886,4.886,0,0,0,.939-3.311V12.249A.307.307,0,0,0,554.949,11.9Z",
    transform: "translate(-503.701 -5.247)",
    fill: "#003d69"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_8",
    "data-name": "Group 8",
    transform: "translate(738.454 6.636)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7",
    "data-name": "Group 7"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_30",
    "data-name": "Path 30",
    d: "M541.306,20.432H522.139a35.636,35.636,0,0,0,30.3,11.1Z",
    transform: "translate(-512.623 39.274)",
    fill: "#ff6b00",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31",
    "data-name": "Path 31",
    d: "M542.958,16.242H526.794l6.063,6.041,12.13,12.091,6.188,6.167a35.281,35.281,0,0,0,8.673-7.461l-5.5-5.483,0,0-2.925-2.925Z",
    transform: "translate(-497.133 25.331)",
    fill: "#e50",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32",
    "data-name": "Path 32",
    d: "M548.876,26.091,536.746,14l-6.189-6.171a35.239,35.239,0,0,0-8.686,7.478l5.5,5.483.013-.022,9.971,9.971,1.393,1.389h16.19Z",
    transform: "translate(-513.512 -2.651)",
    fill: "#003d69",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33",
    "data-name": "Path 33",
    d: "M546.223,38.474a15.13,15.13,0,0,1-12.615-23.43l-5.5-5.483a35.752,35.752,0,0,0-8.11,18.7L536.3,44.515h19.167l-6.063-6.041Z",
    transform: "translate(-519.748 3.099)",
    fill: "#ff6b00",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34",
    "data-name": "Path 34",
    d: "M536.5,30.133,520.19,13.883a35.243,35.243,0,0,0,1.878,16.25Z",
    transform: "translate(-519.94 17.481)",
    fill: "#ff9d00",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35",
    "data-name": "Path 35",
    d: "M545.739,20.432H526.568l11.135,11.1a35.309,35.309,0,0,0,4.968-.961,35.568,35.568,0,0,0,9.257-3.968Z",
    transform: "translate(-497.885 39.274)",
    fill: "#ff9d00",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_36",
    "data-name": "Path 36",
    d: "M563.594,28.224,547.365,12.052H528.112l6.063,6.041h3.181a15.13,15.13,0,0,1,12.607,23.447l5.5,5.483A35.812,35.812,0,0,0,563.594,28.224Z",
    transform: "translate(-492.747 11.388)",
    fill: "#00749d",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_37",
    "data-name": "Path 37",
    d: "M546.9,12.052H532.561l16.229,16.172A35.327,35.327,0,0,0,546.9,12.052Z",
    transform: "translate(-477.942 11.388)",
    fill: "#00acda",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38",
    "data-name": "Path 38",
    d: "M557.412,17.989A35.644,35.644,0,0,0,527.183,6.88l11.144,11.109Z",
    transform: "translate(-495.838 -6.636)",
    fill: "#00acda",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39",
    "data-name": "Path 39",
    d: "M549.321,17.8,538.177,6.692a35.118,35.118,0,0,0-5.042.969,35.509,35.509,0,0,0-9.257,3.968l6.189,6.171Z",
    transform: "translate(-506.833 -6.448)",
    fill: "#00749d",
    fillRule: "evenodd"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSanadLogo);
export default __webpack_public_path__ + "static/media/Sanad_logo.fa3ae482f78835d72a20f1fe4bcb248f.svg";
export { ForwardRef as ReactComponent };